import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@microbeta/ui";
import { useTranslation } from "react-i18next";
import { languages } from "../../../../features/i18n/i18n";
import styles from "./language-selector.module.scss";

export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className={styles.languageSelector}>
      <Select
        value={i18n.resolvedLanguage || i18n.language}
        onValueChange={handleLanguageChange}
      >
        <SelectTrigger className={styles.trigger}>
          <SelectValue placeholder="Select language..." />
        </SelectTrigger>
        <SelectContent>
          {languages.map((language) => (
            <SelectItem key={language.code} value={language.code}>
              <span className={styles.languageOption}>
                <span className={styles.flag}>{language.flag}</span>
                <span className={styles.name}>{language.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
